module.exports = "/static/images/favicon2.png";